module.exports = __webpack_public_path__ + "static/img/logo_noir.1e990ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_noir.png
// module id = y3Dm
// module chunks = 8